<template>
    <div>
    <CDropdown
            inNav
            class="c-header-nav-items"
            placement="bottom-end"
            add-menu-classes="pt-0"
    >
        <template #toggler>
            <CHeaderNavLink>
                <div class="c-avatar">
                    <img
                            src="/img/avatars/custom.png"
                            class="c-avatar-img "
                    />
                </div>
            </CHeaderNavLink>
        </template>
        <CDropdownHeader tag="div" class="text-center" color="light">
            <strong>{{user_name}}</strong>
        </CDropdownHeader>

<!--        <CDropdownItem v-on:click="$router.push({path:'/dashboard/settings/contacts'})">-->
<!--            <CIcon name="cil-user"/>-->
<!--            مخاطبین-->
<!--        </CDropdownItem>-->

        <CDropdownItem  @click="change_password_modal = true">
            <CIcon name="cil-lock-locked"/>
            {{$t('buttons.changePassword')}}
        </CDropdownItem>

        <CDropdownItem v-on:click="log_out">
            <CIcon name="cil-lock-locked"/>
            {{$t('buttons.logout')}}
        </CDropdownItem>

    </CDropdown>
        <CModal
                :show.sync="change_password_modal"
                :no-close-on-backdrop="true"
                :centered="true"
                :title="$t('buttons.changePassword')"
                size="sm"
                color="dark"
        >
            <template #header>
                <h6 class="modal-title">{{$t('buttons.changePassword')}}</h6>
                <CButtonClose @click="change_password_modal = false" class="text-white"/>
            </template>
            <CInput v-model="old_pass" :label="$t('oldPass')"/>
            <CInput v-model="new_pass" :label="$t('newPass')"/>
            <CInput v-model="rpt_pass" :label="$t('rtpPass')"/>
            <template #footer>
                <CButton @click="change_password()"
                         color="danger"
                >{{$t('buttons.changePassword')}}
                </CButton>
                <CButton
                        @click="change_password_modal = false"
                        color="success"
                >{{$t("buttons.cancel")}}
                </CButton>
            </template>
        </CModal>

    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: 'TheHeaderDropdownAccnt',
        data() {
            return {
                itemsCount: 42,
                user_name: '',
                old_pass: '',
                new_pass: '',
                rpt_pass: '',
                change_password_modal:false,
            }
        }
        , mounted() {
            this.user_name = localStorage.getItem("user_name");
        },
        methods: {
            log_out() {
              var self = this;


              const formData = new FormData();
              var url = "LogOff";

              formData.append("mobileNo", localStorage.getItem("mobile"));


              axios.post(url, formData, {}).then(function (response) {

                self.$root.modal_component.show_api_response_modals(response);

                localStorage.setItem("token", "");
                self.$router.push({path: "/pages/login"});

              })
                  .catch(function (error) {
                    console.log(error);
                  });


            },
            change_password(){
                var self = this;


                const formData = new FormData();
                var url = "ChangePass";
                if(self.old_pass==''){
                    this.$root.modal_component.show_validate_errors([this.$t('insertOldPassword')])
                    return false;
                }
                if(self.new_pass==''){
                    this.$root.modal_component.show_validate_errors([this.$t('insertNewPassword')])
                    return false;
                }
                if(self.new_pass!=this.rpt_pass){
                    this.$root.modal_component.show_validate_errors([this.$t('NewPassAndRepeatNotMatch')])
                    return false;
                }
                formData.append("oldPass", self.old_pass);
                formData.append("newPass", self.new_pass);
                formData.append("rNewPass", self.rpt_pass);


                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;
                    self.$root.modal_component.show_api_response_modals(response);

                    if (response.data.statusCode == 0) {
                        self.old_pass= ''
                            self.new_pass= ''
                            self.rpt_pass=''
                            self.change_password_modal=false
                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
        }
    }
</script>

<style scoped>
    .c-icon {
        margin-right: 0.3rem;
    }
</style>
